<template>
  <div class="container">
    <div class="indicator">
      <Steps :current="current" class="stepDiv">
        <Step
          v-for="(step, index) in stepsList"
          :title="step.title"
          :icon="step.icon"
          :key="index"
        ></Step>
      </Steps>
    </div>
    <div class="content">
      <!-- 身份验证 -->
      <div class="identityVertifyView" v-show="current == 0">
        <div class="identityVertifyView" v-show="current == 0">
          <div class="firstPageInput">
            手机号:<input v-model="userPhone" type="password" autocomplete="off" style="position: fixed; left: -99999999px" />
            <Input v-model="userPhone" type="text" class="inputDiv" autocomplete="off"></Input>
          </div>
          <div class="resetPwdSendSMSCodeView firstPageInput">
            验证码:<input v-model="SMSCode" type="password" autocomplete="off" style="position: fixed; left: -99999999px" />
            <Input v-model="SMSCode" type="text" class="inputDiv" autocomplete="off" />
            <Button
              type="primary"
              @click="sendCode"
              :disabled="sendSMSBtnDisable"
            >
              {{ sendBtnTitle }}
            </Button>
            <div>{{ sendText }}</div>
          </div>
        </div>
      </div>
      <div class="finalModifyView" v-show="current == 2">
        <div style="display:block">
          <span class="finalTitle">新密码: </span
          ><Input
            v-model="newPassword"
            class="inputDiv"
            type="password"
          ></Input>
        </div>
        <div style="display:block">
          <span class="finalTitle">确认新密码: </span
          ><Input
            v-model="reNewPassword"
            class="inputDiv"
            type="password"
          ></Input>
        </div>
      </div>
    </div>
    <div class="textBox">
      <div class="promptText">{{ alertText }}</div>
    </div>
    <div class="bottomButton">
      <Button
        class="prevBtn"
        type="primary"
        @click="bottomPrevButtonClick"
        :disabled="current < 2"
      >
        上一步
      </Button>
      <Button
        class="nextBtn"
        type="primary"
        @click="bottomNextButtonClick"
        :disabled="current == 0 && alreadySendCode == false"
      >
        下一步
      </Button>
    </div>
  </div>
</template>

<script>
import { Steps } from 'view-design';
import ykRule from '../../../assets/js/ykRule';
import md5 from 'md5';
import router from '../../../router';

const resetSendSMSCodeURL = '/v1/public/sendResetPwdSmsCode/';
const modifyPasswordURL = '/v1/public/resetPwd';

export default {
  name: 'resetOrModifyPassword',
  data() {
    return {
      stepsList: [
        { title: '身份验证', icon: 'ios-person' },
        { title: '重置密码', icon: 'ios-unlock' },
        { title: '完成设置', icon: 'md-checkmark-circle' }
      ],
      current: 0,
      userPhone: '',
      opreatorOptions: '',
      SMSCode: '',
      codeStatus: true,
      sendBtnTitle: '发送验证码',
      sendText: '',
      oldPassword: '',
      newPassword: '',
      reNewPassword: '',
      alreadySelect: false,
      alreadyQuestVertifyCode: false,
      // 是否已经发送验证码
      alreadySendCode: false,
      // 发送验证码是否禁用
      sendSMSBtnDisable: false,
      alertText: '请输入手机号和验证码'
    };
  },
  components: {
    Steps
  },
  methods: {
    bottomPrevButtonClick() {
      if (this.current == 0) {
        return;
      }
      this.alreadyQuestVertifyCode = false;
      this.alreadySendCode = false;
      this.current -= 2;
    },
    bottomNextButtonClick() {
      if (this.current == 0) {
        ykRule.testPhone('', this.userPhone, result => {
          if (result != null && result != undefined) {
            this.$Message.error(result.message);
            return;
          }
          // 没输入验证码
          if (this.SMSCode == '') {
            this.$Message.error('请输入短信验证码');
            return;
          }
          ykRule.testNumOnly('', this.SMSCode, result => {
            if (result != null && result != undefined) {
              this.$Message.error(result.message);
              return;
            }
            if (this.SMSCode.length != 6) {
              this.$Message.error('验证码必须为6位数');
              return;
            }
            const params = {
              mobile: this.userPhone,
              newPwd: this.pwdmd5,
              smsCode: this.SMSCode
            };
            this.$ajax.post('/v1/public/checkResetPwd', params).then(res => {
              if (res.data.code == 200) {
                this.alertText = '';
                this.current += 2;
              } else {
                this.$Message.error(res.data.msg);
              }
            });
          });
        });
      } else if (this.current == 2) {
        this.resetPassword();
      } else if (this.current == 4) {
        if (this.opreatorOptions == 'reset') {
          // 重置密码
          this.resetPassword();
        } else {
          // 修改密码，和重置密码用同一个接口
          this.resetPassword();
        }
      }
    },
    // type == 1 修改密码 0 重置密码，不需要原密码
    resetPassword() {
      if (this.newPassword == '') {
        this.$Message.error('请输入新密码');
        return;
      }
      if (this.reNewPassword == '') {
        this.$Message.error('请输入确认密码');
        return;
      }

      ykRule.checkPassword(this.newPassword, result => {
        if (result != null && result != undefined) {
          this.$Message.error(result.message);
          return;
        }
        if (this.reNewPassword != this.newPassword) {
          this.$Message.error('两次密码不一致');
          return;
        }
        const pwdmd5 = md5(this.newPassword);
        const req = {
          mobile: this.userPhone,
          newPwd: pwdmd5,
          smsCode: this.SMSCode
        };
        this.$ajax.post(modifyPasswordURL, req).then(res => {
          const { data } = res;
          if (data.code == 200) {
            // TODO: 跳转登录页
            this.$Message.info('修改成功，请重新登录');
            router.push('/login');
          } else {
            this.$Message.error(data.msg);
          }
        });
      });
    },
    sendCode() {
      const url = resetSendSMSCodeURL + this.userPhone;
      if (this.userPhone == '') {
        this.$Message.error('请输入手机号');
        return;
      }
      ykRule.testPhone('', this.userPhone, result => {
        if (result != null && result != undefined) {
          console.log(result);
          this.$Message.error(result.message);
          return;
        }
        this.$ajax.post(url).then(res => {
          const { data } = res;
          if (data.code == 200) {
            this.alreadyQuestVertifyCode = true;
            this.cutDown();
            const a = this.userPhone.replace(
              this.userPhone.substring(3, 7),
              '****'
            );
            this.alertText = `已向您的手机号${a}发送验证码`;
            this.alreadySendCode = true;
          } else {
            this.$Message.error(data.msg);
          }
        });
      });
    },
    cutDown() {
      let seconds = 60;
      this.sendSMSBtnDisable = true;
      const timer = setInterval(() => {
        if (seconds > 0) {
          seconds -= 1;
          this.sendBtnTitle = `${seconds}s后重新发送`;
        } else {
          this.sendSMSBtnDisable = false;
          this.sendBtnTitle = '重新发送';
          clearInterval(timer);
        }
      }, 1000);
    }
  }
};
</script>

<style scoped lang="less">
.container {
  /* text-align: center; */
  font-size: 18px;
  position: relative;
  height: 100%;
  margin: 0 auto;
  padding-top: 150px;
  /* background-image: url('https://img0.baidu.com/it/u=1602278555,3047947323&fm=253&fmt=auto&app=120&f=JPEG?w=1280&h=720'); */
  .indicator {
    width: 50%;
    margin: 0 auto;
  }
  .content {
    padding-top: 80px;
  }
  .textBox {
    margin: 0 auto;
    width: 600px;
    .promptText {
      color: #2d8cf0;
      font-size: 16px;
      margin: 30px 140px 0;
      text-align: left;
      font-family: '行体';
    }
  }

  .identityVertifyView {
    padding-top: 30px;
    text-align: left;
    /* text-align: center; */
    width: 600px;
    margin: 0 auto;
    .firstPageInput {
      padding-left: 50px;
    }
  }
  .bottomButton {
    position: relative;
    margin: 0 auto;
    text-align: left;
    margin-top: 50px;
    padding-left: 130px;
    width: 600px;
    // left: 50%;
    // transform: translateX(-50%);
    button {
      width: 100px;
    }
    .prevBtn {
    }
    .nextBtn {
      margin-left: 100px;
    }
  }

  .inputDiv {
    width: 300px;
    margin-left: 30px;
  }
  .reOrModiOptionsView {
    text-align: center;
  }
  .reOrModiOptionsView .option {
    margin-top: 30px;
  }
  .finalModifyView {
    padding-top: 30px;
    text-align: center;
  }
  .finalTitle {
    display: inline-block;
    width: 100px;
    text-align: end;
    margin-top: 30px;
  }
  .resetPwdSendSMSCodeView {
    /* display: inline-block; */
    margin: 30px auto 0;
  }
}

button {
  margin-left: 10px;
}
</style>
